export default () => ({
    activeIndex: 0,

    goTo(index) {
        const navigationChildren = this.$refs.navigation.querySelectorAll('li')
        const activeNavigationChild = navigationChildren[index]
        const activeChild = this.$refs.track.children[index]
        const margin = navigationChildren[0].offsetLeft

        this.$refs.navigation.scrollTo({
            left: activeNavigationChild.offsetLeft - margin,
            behavior: 'smooth',
        })

        this.$refs.track.scrollTo({
            left: activeChild.offsetLeft,
            behavior: 'smooth',
        })

        this.activeIndex = index
    },

    onScrollEnd() {
        const childWidth = this.$refs.track.offsetWidth

        this.activeIndex = Math.round(this.$refs.track.scrollLeft / childWidth)
    },
})
